import { render, staticRenderFns } from "./Blank.vue?vue&type=template&id=d8b02cca&"
import script from "./Blank.vue?vue&type=script&lang=ts&"
export * from "./Blank.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports